<script>
  let { id, type = 'info', message, duration = 5000, onDismiss } = $props();

  const styles = {
    success: { bg: 'var(--p-success-bg)', fg: 'var(--p-success)', icon: 'fa-circle-check' },
    error:   { bg: 'var(--p-danger-bg)',  fg: 'var(--p-danger)',  icon: 'fa-circle-exclamation' },
    warning: { bg: 'var(--p-warning-bg)', fg: 'var(--p-warning)', icon: 'fa-triangle-exclamation' },
    info:    { bg: 'var(--p-info-bg)',    fg: 'var(--p-info)',    icon: 'fa-circle-info' },
  };
  const style = $derived(styles[type] ?? styles.info);

  $effect(() => {
    if (!duration) return;
    const timer = setTimeout(() => onDismiss?.(id), duration);
    return () => clearTimeout(timer);
  });
</script>

<div class="p-card flex items-start gap-3 p-3 shadow-lg" style="background-color: {style.bg}" role="status">
  <i class="fas {style.icon} mt-0.5" style="color: {style.fg}" aria-hidden="true"></i>
  <p class="flex-1 text-sm">{message}</p>
  <button type="button" class="p-faint hover:opacity-70" aria-label="Dismiss"
          onclick={() => onDismiss?.(id)}>
    <i class="fas fa-xmark" aria-hidden="true"></i>
  </button>
</div>
